import Lottie from "react-lottie";
import animationData from "../../jsons/Loading333.json";

interface Props {
  className: string;
  height: number;
  width: number;
  bgcolor?: string;
}

const Loading = ({ height, width, className, bgcolor }: Partial<Props>) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  return (
    <div
      className={`flex flex-col w-full ${
        bgcolor ? bgcolor : "bg-white"
      } justify-center item-center ${className}`}
    >
      <Lottie
        options={defaultOptions}
        height={height ? height : 100}
        width={width ? width : 100}
      />
    </div>
  );
};

export default Loading;
